import { createEffect, untrack } from "solid-js"
import { Group, Mesh, type Object3D } from "three"
import type { Engine } from "../../core/engine/Engine.type"
import type { EntityGraphNode } from "../../core/engine/EntityGraphNode/EntityGraphNode.type"
import applyEntityRotationToNextObject3DFrame from "../../core/entity/EntityHeading/applyEntityRotationToNextObject3DFrame"
import applyEntityWalkPathToNextObject3DFrame from "../../core/entity/EntityHeading/applyEntityWalkPathToNextObject3DFrame"
import type { APCEntity } from "../../core/entity/EntityType/APC"
import shouldEntityShowFadedFrames from "../../core/entity/shouldEntityShowFadedFrames"
import tmpRng from "../../core/rng/tmpRng"
import { mountOnFrameUpdateToObject3D } from "../../event/GameObject3D/GameObject3DFrameUpdate/GameObject3DFrameUpdate"
import assertClassInDev from "../../ldsh/assertClassInDev"
import { APC_M113_APC_M113_GLTF_Model } from "../gltf_models.generated"
import { appGltfLoader } from "./appGltfLoader"
import applyPlayerColors from "./applyPlayerColors"
import cubicEaseInOutBounce from "./cubicEaseInOutBounce"
import runWithObject3DOwner from "./runWithObject3DOwner"
const totalLoopMs = 1000

// const heights = [1, 2, 2, 3, 3, 4]

export default function makeAPCScene (
  engine: Engine,
  ent: EntityGraphNode<APCEntity>,
  callback: (newGroup: Object3D) => void
): void {
  return appGltfLoader.load(APC_M113_APC_M113_GLTF_Model, function (ModelObj) {
    tmpRng.seed = ent.id
    const { scene } = ModelObj
    // console.log('scene', scene)

    const bodyGroup = scene.getObjectByName('Body') as Group
    assertClassInDev(bodyGroup, Group)
    // bodyGroup.scale.multiplyScalar(1)

    const tracksMesh = scene.getObjectByName('Tracks') as Mesh
    assertClassInDev(tracksMesh, Mesh)
    // tracksMesh.scale.multiplyScalar(1)

    // const wheelScaleX = 3.8
    // const wheelFrontOffsetY = 9.2
    // const wheelBackOffsetY = 8.4

    const defaultHullY = bodyGroup.position.y
    // const defaultHullX = 0

    let entValue = untrack(ent.raw)
    runWithObject3DOwner(scene, () => {
      createEffect(() => {
        entValue = ent.raw()
      })
    })

    mountOnFrameUpdateToObject3D(engine, bodyGroup, (elapsedMs: number, frameAt: number): void => {
      const mod = frameAt % totalLoopMs
      if (shouldEntityShowFadedFrames(entValue)) {
        bodyGroup.position.y = defaultHullY
      } else if (entValue.player_id) {
        bodyGroup.position.y = defaultHullY + (cubicEaseInOutBounce(mod / 500) / 7)
      }
      applyEntityRotationToNextObject3DFrame(scene, elapsedMs)
      applyEntityWalkPathToNextObject3DFrame(scene, elapsedMs)
    })

    applyPlayerColors(engine, scene, ent)

    callback(scene)
  })
}
